document.addEventListener("DOMContentLoaded", () => {
  /* The "Searchanise Search & Discovery" app applies the event.preventDefault() method on the checkout button click.
  *  After data processing it adds a 'se-processed' class to the button, bot does not provide a redirect to the checkout.
  *  The following code does.
  */
  const checkoutButtonSelectors = '.cart-form [type="submit"][name="checkout"], .cart-form .additional-checkout-button, form[action="/checkout"] [type="submit"], #cart .action_button[type="submit"], #checkout, .pt-cart a[href^="/checkout"]';
  const checkoutButtons = document.querySelectorAll(checkoutButtonSelectors);
  const MUOptions = { attributes: true, attributeFilter: ['class'] };

  function MUCallback(mutationList) {
    mutationList.forEach(function(mutation) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class' &&
        mutation.target.classList.contains('se-processed')
        ) {
          mutation.target.click();
      }
    })
  }

  for (let i = 0; i < checkoutButtons.length; i++) {
    const observer = new MutationObserver(MUCallback);
    observer.observe(checkoutButtons[i], MUOptions);
  }
});
